/*****************************************************************************
 *   © Copyright 2021   Quantitative Software Management, Inc.               *
 *              --  All rights reserved.  --                                 *
 *   Unpublished -- rights reserved under the Copyright Laws                 *
 *   of the United States.                                                   *
 *                                                                           *
 *   This computer software is protected by trade secret, copyright law,     *
 *   and international treaties and contains proprietary and confidential    *
 *   trade secrets of Quantitative Software Management, Inc.  Unauthorized   *
 *   use, reproduction, or distribution of this program or any portion of    *
 *   it will result in severe civil or criminal penalties and will be        *
 *   prosecuted to the full extent of the law.                               *
 *                                                                           *
 *   Use, duplication, or disclosure by the Government is subject to         *
 *   restrictions as set forth in                                            *
 *      (i) a license agreement incorporated in the contract,                *
 *      (ii) the definition of "restricted rights" in paragraph (c)(1)(ii)   *
 *           of DFARS 252.227-7013 (1988), and                               *
 *      (iii) the definition of "restricted rights" in paragraph (a) of      *
 *            FAR 52.227-14, Alt III (Jun 1987) or                           *
 *      (iv) FAR 52.227-19 (Jun 1987), as applicable.                        *
 *   For purposes of the FAR, this software shall be deemed to               *
 *   be "unpublished" and licensed with disclosure prohibitions.             *
 *   Contractor/Manufacturer is   Quantitative Software Management, Inc.     *
 *                                                                           *
 *****************************************************************************/

import { Injectable, Inject } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import { ErrorService } from './Error.Service';
import { BaseUtilityService } from './BaseUtility.Service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { LoadingService } from './loading.service';
import { Title } from '@angular/platform-browser';

export enum ApplicationType {
  Authority = 'Authority',  //used inUtilityService. _appUrlNames to hold the authority section of the url
  Web = 'Web',
  Admin = 'Admin',
  Collab = 'Collab'
}

export enum NotificationType {
  UNDEFINED = 0,
  NOTIFIER_SUCCESS = 1500,
  NOTIFIER_ERROR = 999999,
  NOTIFIER_LONGSUCCESS = 10000,
  NOTIFIER_MEDIUMSUCCESS = 3000
}

@Injectable({
  providedIn: 'root'
})

export class UtilityService extends BaseUtilityService {
  constructor(public http: HttpClient, @Inject(DOCUMENT) document: any, public errorService: ErrorService, public router: Router,
public loadingService: LoadingService, public titleService: Title) {
    super(http, document, router, loadingService, titleService);
  }

  public SetWebPagePopIn(popIn: boolean) : Observable<any> {
    let baseUrl = "/qsmweb/Operation/SetCollabIFrameSetting.ashx";
    return popIn ? this.http.get<any>(baseUrl + '?popin=true', this.StringReturnOptions(this.AjaxOptions()) ) :
      this.http.get<any>(baseUrl, this.StringReturnOptions(this.AjaxOptions()));
  }

  public AddRemoveGridDataToSessionStorage(addData: boolean, zoneId: string, data: any = null) {
    if (addData) {
      sessionStorage.setItem(`gridData_${zoneId}`, JSON.stringify(data));
    }
    else {
      sessionStorage.removeItem(`gridData_${zoneId}`);
    }   
  }

  public GetDataFromSessionStorage(zoneId: string): any {
    return JSON.parse(sessionStorage.getItem(`gridData_${zoneId}`));
  }
}
